// Resources Catalog
import React from 'react';
import ReactDOM from 'react-dom';
import ResourceCatalog from './apps/ResourceCatalog/ResourceCatalog';

const App = () => <ResourceCatalog />;

ReactDOM.render(<App />, document.getElementById('app-resource-catalog'));
